<template>
  <v-app>
    <Banner />
    <v-content role="main">
      <v-container v-if="isReady && !messageBox">
        <v-row v-if="isGuestBrowse">
          <!-- STEPPER -->

          <v-col cols="3" class="stepperContainer">
            <Stepper :steps="stepsGuest" :currentStep="currentStep" />
          </v-col>

          <v-col>
            <!-- STEP 1 -->

            <v-form
              v-model="isFormValid"
              @keyup.native.enter="onEnterKey"
              @submit.prevent=""
              ref="form"
            >
              <v-card class="formStep" v-if="currentStep === 1">
                <div class="stepNumber">Step {{ currentStep }}</div>
                <h2>Please confirm your identity</h2>
                <v-text-field
                  v-for="field in fieldsStep1Guest"
                  v-model.trim="fieldValues[field.id]"
                  :ref="field.id"
                  :key="field.id"
                  :label="field.label"
                  :rules="field.rules"
                  :placeholder="field.placeholder || ' '"
                  outlined
                  :validate-on-blur="isValidateOnBlur"
                  :hint="field.hint"
                ></v-text-field>
                <DatePicker
                  :date="fieldValues.dateOfBirth"
                  label="Date of birth"
                  format="dmy"
                  @change="setDOB"
                  :isRequired="false"
                  :isPastDate="true"
                  :validate-on-blur="isValidateOnBlur"
                />
                <div>
                  <small>*For EFSG users, do not enter date of birth</small>
                </div>
              </v-card>

              <!-- STEP 2 -->

              <v-card class="formStep" v-if="currentStep === 2">
                <div class="stepNumber">Step {{ currentStep }}</div>
                <h2>Set password</h2>
                <div class="subtitle">
                  Your new password will take
                  <strong>up to 30 minutes</strong> to become active.
                </div>
                <Password
                  ref="password"
                  :password="password"
                  :rules="[rules.required, rules.min8chrs]"
                  @change="setPassword"
                  :validate-on-blur="isValidateOnBlur"
                ></Password>
                <div class="passwordHelp">
                  <div>Please include:</div>
                  <ul>
                    <li>At least 8 characters</li>
                    <li>Upper and lower case</li>
                    <li>At least one number</li>
                    <li>No previous passwords</li>
                    <li>No common patterns (e.g. AAA, 123)</li>
                    <li>No repeating characters</li>
                    <li>No spaces</li>
                  </ul>
                </div>
              </v-card>

              <!-- STEP 3 -->
            </v-form>

            <!-- STEP 4 -->

            <v-card class="formStep" v-if="currentStep === 3">
              <div class="stepNumber">Step {{ currentStep }}</div>
              <h2>Confirmation</h2>
              <div class="subtitle">
                Dear {{ fieldValues.firstName | capitalize }}
                {{ fieldValues.lastName | capitalize }}, your Account has been
                activated.
                <div style="margin-top: 0.5em">
                  You may now close this window.
                </div>
              </div>
            </v-card>

            <!-- BUTTONS -->

            <div class="buttons">
              <v-btn
                v-if="!(isGuestBrowse && currentStep === 3) && currentStep === 2"
                @click="back"
                depressed
                >Back
              </v-btn>
              <v-btn @click="proceedGuest" depressed class="primary" ref="next"
                v-if="!(isGuestBrowse && currentStep === 3)"
                >{{ nextButtonLabel }}
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row v-else>
          <!-- STEPPER -->

          <v-col cols="3" class="stepperContainer">
            <Stepper :steps="steps" :currentStep="currentStep" />
          </v-col>

          <v-col>
            <!-- STEP 1 -->

            <v-form
              v-model="isFormValid"
              @keyup.native.enter="onEnterKey"
              @submit.prevent=""
              ref="form"
            >
              <v-card class="formStep" v-if="currentStep === 1">
                <div class="stepNumber">Step {{ currentStep }}</div>
                <h2>Please confirm your identity</h2>
                <v-text-field
                  v-for="field in fieldsStep1"
                  v-model.trim="fieldValues[field.id]"
                  :ref="field.id"
                  :key="field.id"
                  :label="field.label"
                  :rules="field.rules"
                  :placeholder="field.placeholder || ' '"
                  outlined
                  :validate-on-blur="isValidateOnBlur"
                  :hint="field.hint"
                ></v-text-field>
                <DatePicker
                  :date="fieldValues.dateOfBirth"
                  label="Date of birth"
                  format="dmy"
                  @change="setDOB"
                  :isRequired="false"
                  :isPastDate="true"
                  :validate-on-blur="isValidateOnBlur"
                />
                <div>
                  <small>*For EFSG users, do not enter date of birth</small>
                </div>
              </v-card>

              <!-- STEP 2 -->

              <v-card class="formStep" v-if="currentStep === 2">
                <div class="stepNumber">Step {{ currentStep }}</div>
                <h2>Set password</h2>
                <div class="subtitle">
                  Your new password will take
                  <strong>up to 30 minutes</strong> to become active.
                </div>
                <Password
                  ref="password"
                  :password="password"
                  :rules="[rules.required, rules.min8chrs]"
                  @change="setPassword"
                  :validate-on-blur="isValidateOnBlur"
                ></Password>
                <div class="passwordHelp">
                  <div>Please include:</div>
                  <ul>
                    <li>At least 8 characters</li>
                    <li>Upper and lower case</li>
                    <li>At least one number</li>
                    <li>No previous passwords</li>
                    <li>No common patterns (e.g. AAA, 123)</li>
                    <li>No repeating characters</li>
                    <li>No spaces</li>
                  </ul>
                </div>
              </v-card>

              <!-- STEP 3 -->

              <v-card class="formStep" v-if="currentStep === 3">
                <div class="stepNumber">Step {{ currentStep }}</div>
                <h2>Secret questions</h2>
                <div class="subtitle">
                  If you forget your password, you can use the secret questions
                  and answers below to reset it securely. Choose answers only
                  you would know.
                </div>
                <fieldset v-for="questionNumber in 3" :key="questionNumber">
                  <v-select
                    v-model="answers[questionNumber - 1].question"
                    :items="questions"
                    :label="`Question ${questionNumber}`"
                    :placeholder="
                      answers[questionNumber - 1].question ? null : ' '
                    "
                    outlined
                    :ref="'question' + questionNumber"
                    :rules="[rules.required]"
                    @keydown.native="ie11BackspaceFix"
                    :validate-on-blur="isValidateOnBlur"
                  ></v-select>

                  <v-text-field
                    v-model.trim="answers[questionNumber - 1].answer"
                    label="Answer"
                    placeholder=" "
                    outlined
                    :rules="[rules.required, rules.min4chrs]"
                    maxlength="32"
                    :validate-on-blur="isValidateOnBlur"
                  ></v-text-field>
                </fieldset>
              </v-card>
            </v-form>

            <!-- STEP 4 -->

            <v-card class="formStep" v-if="currentStep === 4">
              <div class="stepNumber">Step {{ currentStep }}</div>
              <h2>Portal login</h2>
              <div class="subtitle">
                Dear {{ fieldValues.firstName | capitalize }}
                {{ fieldValues.lastName | capitalize }}, your Portal Account has
                been activated.
                <div style="margin-top: 0.5em">
                  Click 'Continue' to log in to your Portal Account.
                </div>
              </div>
            </v-card>

            <!-- BUTTONS -->

            <div class="buttons">
              <v-btn
                v-if="currentStep === 2 || currentStep === 3"
                @click="back"
                depressed
                >Back
              </v-btn>
              <v-btn @click="proceed" depressed class="primary" ref="next"
                >{{ nextButtonLabel }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <MessageBox
        v-if="messageBox"
        :icon="messageBox.icon"
        :title="messageBox.title"
        :detail="messageBox.detail"
        :buttonText="messageBox.buttonText"
        @click="messageBox.onButtonClick"
      />
    </v-content>

    <!-- app wide components -->
    <BlockUI v-if="isLoading" />
  </v-app>
</template>

<script>
import { Stepper } from '@nswdoe/doe-ui-core'
import Banner from '@/components/Banner'
import DatePicker from '@/components/DatePicker'
import Password from '@/components/Password'
import MessageBox from '@/components/MessageBox'
import BlockUI from '@/components/BlockUI'
import Axios from 'axios'

const apiRoot = process.env.VUE_APP_ROOT_API
const required = value => !!value || 'Please fill out this field'
const EDConnectContact = `EDConnect on <strong>1300 32 32 32</strong> during business hours`

export default {
  name: 'App',
  components: {
    Banner,
    Stepper,
    DatePicker,
    Password,
    MessageBox,
    BlockUI
  },

  data() {
    return {
      isLoading: false,
      isFormValid: false,
      isReady: false, // True if ready to show the form steps (i.e. token is valid and questions have loaded)
      isValidateOnBlur: true,
      steps: [
        { name: 'Confirm identity' },
        { name: 'Set password', status: 'disabled' },
        { name: 'Secret questions', status: 'disabled' },
        { name: 'Portal login', status: 'disabled' }
      ],
      stepsGuest: [
        { name: 'Confirm identity' },
        { name: 'Set password', status: 'disabled' },
        { name: 'Confirmation', status: 'disabled' }
      ],
      currentStep: 1,
      fieldValues: {
        userId: '',
        firstName: '',
        lastName: '',
        email: '',
        dateOfBirth: '',
        activationToken: ''
      },
      password: '',
      questions: [
        'Who is your favourite historical character',
        'Blah',
        'blah...'
      ],
      answers: [
        { question: '', answer: '', position: '1' },
        { question: '', answer: '', position: '2' },
        { question: '', answer: '', position: '3' }
      ],
      rules: {
        required: required,
        min4chrs: value =>
          (value && value.length >= 4) || 'Your answer must be at least 4chrs',
        min8chrs: value =>
          (value && value.length >= 8) || 'Your password must be at least 8chrs'
      },
      attemptsRemaining: 3, // Number of verification attempts remaining

      // Displays a message box when populated with a message box parameter object, e.g.
      // { icon: 'check', title: 'Saved', detail: 'Record updated successfully', buttonText: 'OK', onButtonClick: function(){} }
      messageBox: null,

      detUserId: 'default_detUserId'
    }
  },

  computed: {
    // for guests, and the URL is https://activation.education.nsw.gov.au/?token=xxxx&role=guest_browse
    isGuestBrowse() {
      const urlParams = new URLSearchParams(location.search)
      return urlParams.get('role') === 'guest_browse'
    },

    isOffline() {
      return this.token === 'TEST_MODE' || location.hostname === 'localhost' // If true, UI will run without API calls
    },

    token() {
      // Token arrives in url param, wrapped in asterisks...
      // return location.search.replace('?token=', '').replace(/\*/g, '')

      // Update for the new guest role - parse URL search params to handle multiple query parameters
      // Example: token=25ef6094c4f675b4ee5d59d53b4d7a8bebd53f65e1a2b30492f04a9785be0b4c941e329804a1ac8903cc1beea6585b79
      const urlParams = new URLSearchParams(location.search)
      const token = urlParams.get('token')
      return token
    },

    nextButtonLabel() {
      if (this.currentStep === 1) {
        return 'Verify'
      }

      if (this.isGuestBrowse) {
        return this.currentStep === 3 ? 'Continue' : 'Next'
      } else {
        return this.currentStep === 4 ? 'Continue' : 'Next'
      }
    },

    fieldsStep1() {
      return [
        {
          id: 'email',
          label: 'Email address',
          rules: [
            v => !v || /\S+@\S+\.\S+/.test(v) || 'Invalid Email address',
            required
          ]
        },
        {
          id: 'userId',
          label: 'DET Username',
          rules: [required],
          placeholder: 'e.g. jane.citizen'
        },
        {
          id: 'firstName',
          label: 'First name',
          rules: [required]
        },
        {
          id: 'lastName',
          label: 'Last name',
          rules: [required]
        }
      ]
    },

    fieldsStep1Guest() {
      return [
        {
          id: 'email',
          label: 'Personal email address',
          rules: [
            v =>
              !v || /\S+@\S+\.\S+/.test(v) || 'Invalid personal email address',
            required
          ]
        },
        {
          id: 'userId',
          label: 'DET Username',
          rules: [required],
          placeholder: 'e.g. jane.citizen'
        },
        {
          id: 'firstName',
          label: 'First name',
          rules: [required]
        },
        {
          id: 'lastName',
          label: 'Last name',
          rules: [required]
        }
      ]
    },

    isAnswersValid() {
      // Returns true if no questions or answers have been repeated
      return !this.answers.find((answer, answerIdx) => {
        return this.answers.find((otherAnswer, otherIdx) => {
          return (
            otherIdx !== answerIdx &&
            (answer.question === otherAnswer.question ||
              answer.answer === otherAnswer.answer)
          )
        })
      })
    }
  },

  methods: {
    setDOB(val) {
      this.fieldValues.dateOfBirth = val
    },

    setPassword(val) {
      this.password = val
    },

    onEnterKey(e) {
      e.target.blur() // Takes focus off current field so validation can take place
      this.proceed()
    },

    proceed() {
      if (this.isLoading) {
        return
      }
      this.isValidateOnBlur = false // Ensure any invalid fields continue to display their error messages until corrected (even when focused)
      this.$refs.form.validate() // Ensure all fields for the current step are updated with any error messages
      let firstInvalidField = this.$refs.form.inputs.find(
        input => input.hasError
      )
      if (firstInvalidField) {
        // If any fields are invalid, go back to the first of them...
        firstInvalidField.focus()
        return
      }
      this.isValidateOnBlur = true
      if (this.currentStep === 1) {
        if (this.fieldValues.dateOfBirth === '') {
          this.fieldValues.dateOfBirth = '01/01/1901'
        }
        this.verifyIdentity()
      } else if (this.currentStep === 2) {
        this.getQuestions()
      } else if (this.currentStep === 3) {
        if (this.isAnswersValid) {
          this.activateAccount()
        } else {
          this.messageBox = {
            icon: 'mdi-hand',
            title: `Please choose unique questions and answers`,
            detail: `You must answer three different questions without repeating any answers.`,
            buttonText: 'Back to Secret Questions',
            onButtonClick: () => (this.messageBox = null)
          }
        }
      } else if (this.currentStep === 4) {
        // All steps complete - redirect to
        location.href = process.env.VUE_APP_EXTRANET_URL
      }
    },

    proceedGuest() {
      if (this.isLoading) {
        return
      }
      this.isValidateOnBlur = false // Ensure any invalid fields continue to display their error messages until corrected (even when focused)
      this.$refs.form.validate() // Ensure all fields for the current step are updated with any error messages
      let firstInvalidField = this.$refs.form.inputs.find(
        input => input.hasError
      )
      if (firstInvalidField) {
        // If any fields are invalid, go back to the first of them...
        firstInvalidField.focus()
        return
      }
      this.isValidateOnBlur = true
      if (this.currentStep === 1) {
        if (this.fieldValues.dateOfBirth === '') {
          this.fieldValues.dateOfBirth = '01/01/1901'
        }
        this.verifyIdentity()
      } else if (this.currentStep === 2) {
        // For guest flow, go directly to account activation after password
        this.activateAccount()
      } else if (this.currentStep === 3) {
        // All steps complete - redirect to
        location.href = process.env.VUE_APP_EXTRANET_URL
      }
    },

    next() {
      this.steps[this.currentStep - 1].status = 'complete'
      this.currentStep++
      this.focusFirstField()
    },

    back() {
      this.currentStep--
      this.steps[this.currentStep - 1].status = ''
      this.focusFirstField()
    },

    focusFirstField() {
      // Timeout necessary to ensure fields have rendered before setting focus
      setTimeout(() => {
        if (this.isGuestBrowse) {
          // guest flow
          if (this.currentStep === 1) {
            this.$refs.email[0].focus()
          } else if (this.currentStep === 2) {
            this.$refs.password.$refs.input.focus()
          }
        } else {
          // regular flow
          if (this.currentStep === 1) {
            this.$refs.email[0].focus()
          } else if (this.currentStep === 2) {
            this.$refs.password.$refs.input.focus()
          } else if (this.currentStep === 3) {
            this.$refs.question1[0].focus()
          }
        }
      }, 0)
    },

    ie11BackspaceFix(e) {
      /*
        v-selects don't work correctly with IE11. They lose the selected value (a bug with placeholders)
        and they navigate away from the page if Backspace is hit.

        The placeholder issue is fixed by not using placeholders. However empty placeholders have to be set
        to achieve the label size & positioning requested by UX. So instead we now only set an empty placeholder
        when no droplist value is selected. This seems to fix the issue.

        The backspace issue is fixed simply by discarding backspace events.
      */
      if (e.key === 'Backspace') {
        e.preventDefault()
      }
    },

    getApiErrorMessage(response) {
      try {
        return response.response.data.errorMessage
      } catch (e) {
        return null
      }
    },

    // API calls ---------------------------------------

    validateToken() {
      // Validate token before showing steps 1-4...
      if (this.isOffline) {
        this.messageBox = {
          icon: 'mdi-wifi-off',
          title: `OFFLINE TEST MODE`,
          detail: `This app is operating in offline test mode. You can use the user-interface to examine the fields and validation, but no real API calls will be made.`,
          buttonText: `START`,
          onButtonClick: () => {
            this.isReady = true
            this.focusFirstField()
            this.messageBox = null
          }
        }
        return
      }

      this.isLoading = true
      Axios.get(`${apiRoot}/validate-token/${this.token}`)
        .then(response => {
          this.detUserId = response.data.username
          this.fieldValues.activationToken = this.token
          console.log('this.detUserId: ' + this.detUserId)
          console.log('this.token: ' + this.token)
          this.isReady = true // Shows steps 1-4
          this.focusFirstField()
        })
        .catch(e => {
          let error = this.getApiErrorMessage(e)

          if (error === 'Activation Token may already be used.') {
            this.messageBox = {
              icon: 'check',
              title: 'Account already activated',
              detail: `It appears that your account has already been activated. Please log in below. Alternatively contact ${EDConnectContact} to assist you with any problems.`,
              buttonText: `LOG IN`,
              onButtonClick: () =>
                (location.href = process.env.VUE_APP_EXTRANET_URL)
            }
            return
          }

          if (!error || error === 'Token expired') {
            error = 'Activation email has expired'
          }
          this.messageBox = {
            icon: 'mdi-av-timer',
            title: error,
            detail: `For security reasons, please request a new activation email.`,
            buttonText: `Resend activation email`,
            onButtonClick: this.resendEmail
          }
          // Ensures the Captcha badge only displays for this reactivation step. Our CSS hides it otherwise.
          document.getElementsByClassName(
            'grecaptcha-badge'
          )[0].style.visibility = ''
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    getQuestions() {
      if (this.isOffline) {
        this.next()
      }
      if (this.isLoading || this.isOffline) {
        return
      }
      this.isLoading = true
      Axios.get(`${apiRoot}/activation-questions/${this.token}`)
        .then(response => {
          console.log('Step 1')
          //this.questions = response.data.questions.map(q => q.question)
          this.questions = response.data
          console.log('Step 2')
          this.next()
        })
        .catch(() => {
          this.messageBox = {
            title: `Sorry, an error has occurred.`,
            detail: `We were unable to retrieve security information. Please try again or contact ${EDConnectContact} to assist you in activating your account.`,
            buttonText: `Retry`,
            onButtonClick: () => this.getQuestions()
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    resendEmail() {
      // Resend activation email after successful reCAPTCHA...
      if (this.isLoading) {
        return
      }

      if (!window.grecaptcha) {
        this.messageBox = {
          title: `Failed to send account activation email`,
          detail: `An Account Activation Email cannot be sent right now because of an error with Google reCAPTCHA. Please contact ${EDConnectContact} to assist you in activating your account.`,
          onButtonClick: ''
        }
        return
      }

      this.isLoading = true
      window.grecaptcha
        .execute(process.env.VUE_APP_CAPTCHA_KEY, {
          action: 'validatecaptcha'
        })
        .then(captchaToken => {
          Axios.post(`${apiRoot}/resend-activation-token`, {
            token: this.token,
            captcha: captchaToken
          })
            .then(() => {
              this.messageBox = {
                icon: 'send',
                title: `Account activation email sent!`,
                detail: `Please check your email (including your junk folder). It may take several minutes to arrive.`,
                onButtonClick: ''
              }
            })
            .catch(e => {
              this.messageBox = {
                title:
                  this.getApiErrorMessage(e) ||
                  `Unable to send account activation email`,
                detail: `Please retry or contact ${EDConnectContact} to assist you in activating your account.`,
                buttonText: 'Retry',
                onButtonClick: () => location.reload()
              }
            })
            .finally(() => {
              this.isLoading = false
            })
        })
    },

    verifyIdentity() {
      // Verify STEP 1 details...
      if (this.isOffline) {
        this.next()
        return
      }

      this.attemptsRemaining--
      this.isLoading = true
      Axios.post(`${apiRoot}/verify-identity`, this.fieldValues)
        .then(() => {
          this.next()
        })
        .catch(() => {
          if (this.attemptsRemaining > 0) {
            this.messageBox = {
              title: `Unable to verify identity`,
              detail: `One or more items are entered incorrectly. You have ${this.attemptsRemaining} attempt(s) remaining.`,
              buttonText: 'Back',
              onButtonClick: () => {
                this.messageBox = null
              }
            }
          } else {
            this.messageBox = {
              title: `Unable to verify identity`,
              detail: `Please call ${EDConnectContact} to assist you in activating your account`,
              onButtonClick: ''
            }
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    activateAccount() {
      // Called after STEP 3 (secret questions)
      if (this.isOffline) {
        this.next()
        return
      }

      this.isLoading = true

      // Different endpoint and payload based on flow type
      const endpoint = this.isGuestBrowse
        ? `${apiRoot}/activation-questions/det_guest_browse`
        : `${apiRoot}/activation-questions`

      const payload = this.isGuestBrowse
        ? {
            password: this.password,
            token: this.token,
            questions: []
          }
        : {
            password: this.password,
            token: this.token,
            questions: this.answers
          }

      Axios.post(endpoint, payload)
        .then(() => {
          this.next()
        })
        .catch(response => {
          let serverMessage = this.getApiErrorMessage(response)
          this.messageBox = {
            title: serverMessage || `Sorry, there was an error.`,
            detail: `${
              serverMessage ? '' : 'Please check your details. '
            }If problems persist, please contact ${EDConnectContact} to assist you in activating your account.`,
            buttonText: this.isGuestBrowse
              ? 'Back to Password'
              : 'Back to Secret Questions',
            onButtonClick: () => {
              this.messageBox = null
              this.back()
            }
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },

  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  mounted() {
    this.validateToken()
  }
}
</script>

<style lang="scss">
@import './scss/app.scss';
</style>
